import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}
export function SEO({
  title = 'Justus Kraft - CRM Experte | Vertriebs-Automatisierung',
  description = 'Mit 16 Jahren mein erstes Gewerbe gegründet. Heute, mit 23 Jahren, helfe ich Unternehmen, ihren Vertrieb durch intelligente CRM-Systeme zu verdoppeln. 110+ zufriedene Kunden.',
  keywords = 'CRM, Vertrieb, Automatisierung, CRM Kraft, Justus Kraft, Vertriebsoptimierung, B2B, B2C, CRM Beratung',
  ogImage = 'https://cdn.magicpatterns.com/uploads/jWaCxaLsc32b7Nk2LkzDn3/62dfd10966fa026013ebcbcf_565aa1ce-min-p-1600_(3).jpg',
  ogType = 'website',
  canonical
}: SEOProps) {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://crm-kraft.de';
  const currentUrl = typeof window !== 'undefined' ? window.location.href : siteUrl;
  const canonicalUrl = canonical || currentUrl;
  const faviconUrl = 'https://cdn.magicpatterns.com/uploads/2DZbG6C862o1ffwWtZP92V/facicon-jk-144.png';
  return <Helmet data-id="element-225">
      {/* Primary Meta Tags */}
      <title data-id="element-226">{title}</title>
      <meta name="title" content={title} data-id="element-227" />
      <meta name="description" content={description} data-id="element-228" />
      <meta name="keywords" content={keywords} data-id="element-229" />

      {/* Language */}
      <html lang="de" data-id="element-230" />

      {/* Favicon - Multiple sizes for different contexts */}
      <link rel="icon" type="image/png" sizes="16x16" href={faviconUrl} data-id="element-231" />
      <link rel="icon" type="image/png" sizes="32x32" href={faviconUrl} data-id="element-232" />
      <link rel="icon" type="image/png" sizes="144x144" href={faviconUrl} data-id="element-233" />
      <link rel="shortcut icon" href={faviconUrl} data-id="element-234" />

      {/* Apple Touch Icon */}
      <link rel="apple-touch-icon" sizes="180x180" href={faviconUrl} data-id="element-235" />

      {/* Android/Chrome */}
      <link rel="icon" type="image/png" sizes="192x192" href={faviconUrl} data-id="element-236" />

      {/* Windows Tile */}
      <meta name="msapplication-TileImage" content={faviconUrl} data-id="element-237" />
      <meta name="msapplication-TileColor" content="#0A0E27" data-id="element-238" />

      {/* Theme Color */}
      <meta name="theme-color" content="#0A0E27" data-id="element-239" />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} data-id="element-240" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-241" />
      <meta property="og:url" content={currentUrl} data-id="element-242" />
      <meta property="og:title" content={title} data-id="element-243" />
      <meta property="og:description" content={description} data-id="element-244" />
      <meta property="og:image" content={ogImage} data-id="element-245" />
      <meta property="og:locale" content="de_DE" data-id="element-246" />
      <meta property="og:site_name" content="CRM Kraft" data-id="element-247" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-248" />
      <meta property="twitter:url" content={currentUrl} data-id="element-249" />
      <meta property="twitter:title" content={title} data-id="element-250" />
      <meta property="twitter:description" content={description} data-id="element-251" />
      <meta property="twitter:image" content={ogImage} data-id="element-252" />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" data-id="element-253" />
      <meta name="author" content="Justus Kraft" data-id="element-254" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-255" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-256" />

      {/* Structured Data - Person/Organization */}
      <script type="application/ld+json" data-id="element-257">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Person',
        name: 'Justus Kraft',
        jobTitle: 'CRM Experte',
        description: 'CRM-Berater und Vertriebs-Automatisierer mit IT- und Vertriebshintergrund',
        url: siteUrl,
        image: ogImage,
        sameAs: [
          // Add social media profiles here when available
        ],
        knowsAbout: ['CRM-Systeme', 'Vertriebsautomatisierung', 'B2B Vertrieb', 'B2C Vertrieb', 'IT-Entwicklung'],
        alumniOf: {
          '@type': 'EducationalOrganization',
          name: 'Selbstständiger Unternehmer seit 16 Jahren'
        }
      })}
      </script>

      {/* Structured Data - Service */}
      <script type="application/ld+json" data-id="element-258">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType: 'CRM Beratung und Automatisierung',
        provider: {
          '@type': 'Person',
          name: 'Justus Kraft'
        },
        areaServed: {
          '@type': 'Country',
          name: 'Deutschland'
        },
        description: 'Professionelle CRM-Beratung und Vertriebsautomatisierung für Unternehmen. Kombination aus IT-Expertise und Vertriebserfahrung.',
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price: '0',
          priceCurrency: 'EUR',
          description: 'Kostenlose Erstberatung'
        }
      })}
      </script>
    </Helmet>;
}